import React, { useState, useEffect } from "react";
import "./UsuarioList.css";
import Usuario from "../supabase/Usuario";
import logo from "../Nido/logo.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {listResennas, updateStateResenna} from "../supabase/Productos";

export default function ReviewList() {
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const [search, setSearch] = useState("");
    const [resennas, setResennas] = useState([]);

    // Fetch all reviews on mount
    useEffect(() => {
        async function fetchData() {
            const data = await listResennas();
            if (data) {
                setResennas(data);
            }
        }
        fetchData();
    }, [user]);

    const handleLogout = () => {
        logout();
        navigate("/");
    };

    const handleDelete = async (id) => {
        if (!window.confirm("¿Estás seguro de eliminar esta reseña?")) return;
        try {
            await updateStateResenna(id);
            setResennas((prev) => prev.filter((r) => r.id !== id));
        } catch (err) {
            console.error(err);
            alert("Error al eliminar reseña");
        }
    };

    const renderStars = (n) => "★★★★★☆☆☆☆☆".slice(5 - n, 10 - n); // n: 0–5

    const filteredResennas = resennas.filter(
        (r) =>
            r.usuario?.toLowerCase().includes(search.toLowerCase()) ||
            r.titulo?.toLowerCase().includes(search.toLowerCase()) ||
            r.descripcion?.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="app-container">
            <header className="topbar">
                <div className="brand">
                    <img src={logo} alt="logo" className="brand-logo" />
                    <nav className="nav">
                        <button className="nav-link" onClick={() => navigate("/home")}>
                            Inicio
                        </button>
                        <button
                            className="nav-link active"
                            onClick={() => navigate("/profile")}
                        >
                            Mi nido
                        </button>
                    </nav>
                    <button
                        className="logout-btn"
                        onClick={handleLogout}
                        title="Cerrar sesión"
                    >
                        ↪
                    </button>
                </div>
                <title>ReANIDArt - Administrar reseñas</title>
            </header>

            <div className="usuario-view-page">
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Buscar reseñas"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <button className="icon">🔍</button>
                </div>

                <main className="usuario-list">
                    {filteredResennas.length > 0 ? (
                        filteredResennas.map((resenna) => (
                            <div className="usuario-card" key={resenna.id}>
                                <div className="usuario-info">
                                    <div className="details">
                                        <span className="username">{resenna.usuario}</span>
                                        <span className="rating-stars">
                                            {renderStars(resenna.valoracion)}
                                        </span>
                                        <span className="username">{resenna.titulo}</span>
                                        <span className="email">
                                            {resenna.descripcion || "Sin descripción"}
                                        </span>
                                    </div>
                                </div>
                                <button
                                    className="delete-btn"
                                    onClick={() => handleDelete(resenna.id)}
                                >
                                    Eliminar
                                </button>
                            </div>
                        ))
                    ) : (
                        <p className="no-results">No se encontraron reseñas.</p>
                    )}
                </main>
            </div>
        </div>
    );
}
